<template>
  <!-- 校内职务架构 -->
  <div class="inside_pages_right_top">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      active-text-color="#1C71FB"
    >
      <el-menu-item
        index="1"
        @click.native="pushRoute('/department_management')"
      >
        组织架构
      </el-menu-item>
      <el-menu-item index="2" @click.native="pushRoute('/class_management')"
        >班级管理</el-menu-item
      >
      <el-submenu index="3">
        <template slot="title" >
            <span style="font-size:16px">安全小组</span>
        </template>
        <el-menu-item index="3-1" @click.native="pushRoute('/security_group')"
          >隐患小组</el-menu-item
        >
        <el-menu-item index="3-2" @click.native="pushRoute('/repairs_group')"
          >报修小组</el-menu-item
        >
      </el-submenu>
      <el-menu-item index="4" @click.native="pushRoute('/job_management')"
        >职务管理</el-menu-item
      >
      <el-menu-item index="5" @click.native="pushRoute('/apartmentBuilding')"
        >宿舍管理</el-menu-item
      >
    </el-menu>
    <!-- <ul>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/department_management'}" @click="$Common.pageJump('/department_management',3)">组织架构</li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/class_management'}" @click="$Common.pageJump('/class_management',3)">班级管理</li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/security_group'}" @click="$Common.pageJump('/security_group',3)">安全小组</li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/job_management'}" @click="$Common.pageJump('/job_management',3)">职务管理</li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/apartmentBuilding'}" @click="$Common.pageJump('/apartmentBuilding',3)">宿舍管理</li>
        </ul> -->
  </div>
</template>

<script>
export default {
  name: "JobStructure",
  components: {},
  props: {},
  data() {
    return {
      activeIndex: "",
      routeSite: this.$Common.getThisTopPage(),
      type:this.$route.query.type
    };
  },
  watch: {
  },
  computed: {},
  methods: {
    pushRoute(route) {
      this.$Common.pageJump(route, 3);
    }
  },
  created() {},
  mounted() {
      if (this.routeSite == '/department_management') {
          this.activeIndex = '1'
      }else if(this.routeSite == '/class_management'){
          this.activeIndex = '2'
      }else if(this.routeSite == '/security_group'){
          this.activeIndex = '3-1'
      }else if(this.routeSite == '/repairs_group'){
          this.activeIndex = '3-2'
      }else if(this.routeSite == '/job_management'){
          this.activeIndex = '4'
      }else if(this.routeSite == '/apartmentBuilding'){
          this.activeIndex = '5'
      }
  }
};
</script>
<style scoped>
@import "/css/base.css";
@import "/css/jobstructure.css";
</style>
